<template>
  <ModalConfirmAction
    title="Excluir câmera"
    message="Você tem certeza que deseja remover esta câmera?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="deleteCamera"
  >
    <template #activator="{ on, attrs }">
      <div class="table-action-box table-action-delete" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
        <span class="table-action-label">Excluir</span>
      </div>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions } from "vuex";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    idCamera: Number,
    codPraca: Number,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      getCamerasByPraca: "cameras/getCamerasByPraca",
    }),
    async deleteCamera() {
      try {
        this.loading = true;
        const response = await apiClient.delete(`cameras/${this.idCamera}`, {});
        if (response.status === 200) {
          this.$toast.success("Câmera excluida com sucesso!");
        } else {
          this.$toast.error("Erro ao excluir câmera...");
        }
      } catch (error) {
        this.$toast.error("Erro ao excluir câmera...");
      } finally {
        await this.getCamerasByPraca({
          cod_praca: this.codPraca,
        });
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
